import React from 'react';
import { BackTop as AntdBackTop, BackTopProps } from 'antd';

const BackTop: React.FunctionComponent<BackTopProps> = (props: BackTopProps) => {
	return <AntdBackTop {...props} />;
};

export default BackTop;
